<template>
  <DialogWrapper v-if="showDialog"
                 :dialog-class="`${dialogClass} ${size} dialog-cmp`"
                 @click-outside="$emit('click-outside')"
                 @closeButtonPressed="closeButton"
                 @enterPressed="enterPressed">
    <template>
      <v-layout column>
        <header class="dialog-cmp-header">
          <slot name="header"></slot>
          <v-btn small outlined @click="$emit('click-close')" v-if="closeIcon"><v-icon>close</v-icon></v-btn>
        </header>
        <div class="dialog-cmp-content">
          <slot name="content"></slot>
        </div>
        <v-divider></v-divider>
        <footer class="dialog-cmp-footer">
          <slot name="footer"></slot>
        </footer>
      </v-layout>
    </template>
  </DialogWrapper>
</template>
<script>
  import DialogWrapper from './DialogWrapper'

  export default {
    deprecated: "(DialogCmp) - Please use a Modal from the design system instead",
    props: {
      showDialog: {
        type: Boolean,
        required: true
      },
      dialogClass: {
        type: String,
        required: false
      },
      size: {
        type: String,
        default: 'sm', // required
        validator: prop => ['sm', 'md'].includes(prop)
      },
      closeIcon: {
        type: Boolean,
        default: false
      }
    },
    components: {DialogWrapper},
    methods: {
      closeButton() {
        this.$emit("closeButtonPressed", false);
      },
      enterPressed() {
        this.$emit("enterPressed");
      }
    }
  }
</script>

<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .dialog-cmp {

    height: auto;
    min-height: 100px;
    min-width: 300px;
    background-color: $white-color-1;
    box-shadow: $boxShadow;
    font-family: var(--font3);
    display: flex;
    padding: 15px 15px 5px 15px;

    .v-btn {
      border: 0;
    }

    &.sm {
      width: 570px;
    }

    &.md {
      width: 700px;
    }

    @include sm-and-down {
      /* offset when opened in frontage layout iframe */
      top: 0px;
      left: 0;

      &:not(.v-dialog--fullscreen) {
        min-height: 100%;
        min-width: 300px;
        position: relative;
        height: 100%;
        margin: initial;
      }
    }

    .dialog-cmp-header,
    .dialog-cmp-content,
    .dialog-cmp-footer {
      padding: 5px 15px 15px 15px;

      @include sm-and-down {
        padding-inline-start: 0;
      }
    }

    .dialog-cmp-header {
      font-weight: 600;
      font-size: 24px;
      font-family: var(--font3);
      display: flex;
      justify-content: space-between;
    }

    .dialog-cmp-footer {
      padding-bottom: 0;
      @include i-text-align(right)
    }

    .v-divider {
      border-color: $dividerColor;
      order: unset;
    }

    @include sm-and-down {
      .dialog-cmp-content {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .staff__dialog {
    overflow: visible;

    .dialog-cmp-header,
    .dialog-cmp-content,
    .dialog-cmp-footer {
      font-family: var(--primary-font-family) !important;
    }

    .dialog-cmp-header {
      font-size: 18px;
      @include sm-and-down {
        font-size: 24px;
      }
    }

    @include sm-and-down {
      .dialog-cmp-content {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
      }
    }
  }
</style>
